/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Form, Button, Spinner, Modal, Nav, FormGroup } from 'react-bootstrap';

// project imports
import { ACCESS_TOKEN, REFRESH_TOKEN } from 'shared/settings/token';
import { loginWithRes } from 'shared/settings/auth';
import Validators from 'shared/validators';
import store from 'features/store';
import AuthService from 'shared/services/authService';
import { mobileNumberFormat } from 'shared/modifiers';

// style imports
import { appleRegister, facebookRegister, googleRegister } from 'shared/images/images';
import AppleSignin from 'react-apple-signin-auth';
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { socialAuthCredential } from 'shared/settings/socialMediaConfig';
import authService from 'shared/services/authService';
//import LogRocket from 'logrocket';
//import { logRocketDevId } from 'shared/settings/config';

import './Signin.scss';
import { showAndHideJiraButton } from 'shared/jira-button';
import { authErrorMessage } from 'features/config/systemmessages';
import { SignTermsAndCondtions } from '../base/public';
import { addDataLayer, getFormattedAppleLinkAndMessage, pmAutoNavigateToNextScreen, setPmSteps } from 'shared/utils/utils';


/**


@Author Karthik

@param

@return html code for sign-in Page

**/


/**
 * make authentic user to enter the system
 * 
**/

export class Signin extends Component {

    constructor(props) {
        super(props);
        this.timeoutInterval = null;
        this.state = {
            // toggle input type
            showPassword: false,
            confirmPassword: false,

            // form
            formValid: false,
            formControls: {
                email: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.email(), Validators.maxLength(60)] },
                password: { value: '', valid: false, error: '', validators: [Validators.required()] }
            },
            remember: false,
            errorMsg: '',
            nickNameErroMsg: '',
            nameError: true,
            tempVerifyPhoneNumber: '',
            phoneNumberDisabled: false,

            /* Register form control */
            registerFormControl: {
                firstname: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.validateNameLength(1, 45, 'First Name')] },
                lastname: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.validateNameLength(1, 45, 'Last Name')] },
                nickname: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.validateNameLength(1, 45, 'Nick Name')] },
                email: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.email(), Validators.maxLength(60)] },
                retypeEmail: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.email(), Validators.maxLength(60)] },
                // phonenumber: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.mobile()] },
            },
            showPhoneNumberModel: false,

            passwordStrength: { status: 0, lower: false, upper: false, numeric: false, count: false, symbol: false },

            // loading
            signinFormLoading: false,
            toggleSignInModal: false,
            innerWidth: window.innerWidth,
            mobileModal: false,
            isOtpSent: false,
            mobile: {
                otp: {value: '',   error: '', valid: false },
                valid: false 
            },
            otpMessage: '',
            otpSuccess: false,
            isVerified: false,
            getOtpType: '',

            // Tab
            activeKey: "Sign-In",
            proxyEmail: false,
            welcomeMessageShow: false,
            displayname: null,
            signUpLading: false,
            signInError: '',
            signUpError: '',

            // Check details
            details: {
                nickname: {
                    loading: false,
                    exists: false,
                    message: ""
                },
                email: {
                    loading: false,
                    exists: false,
                    message: ""
                }
            },
            signTermsConditions: false
        };
    }

    /**
     * 
     * Called after component mount
     * 
     */
    componentDidMount() {

        /* Adding event listenr for resize */
        window.addEventListener('resize', this.updateDimensions);

        /* Setting which want to show. Sign-In or Sign-Up page */
        this.setState({
            activeKey: this.props.toggleSignInModal.mode
        })
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    /**
     * 
     * Called when resize the screen.
     * 
     */
    updateDimensions = () => {
        this.setState({
            ...this.state,
            innerWidth: window.innerWidth
        });
    }

    /* toggles password to show or hide on clicking eye icon */
    togglePassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    };

    /* toggles confirm password to show or hide on clicking eye icon */
    toggleConfirmPassword = () => {
        this.setState({ confirmPassword: !this.state.confirmPassword });
    };

    /* checks whether the input is valid or not */
    onInputValidation = (event, formName) => {
        let controlError = '';
    
        const validateName = (value) => {
            const alphabeticPattern = /^[a-zA-Z0-9\sáéíóúüñÁÉÍÓÚÜÑÊêÂâÎîÔôÛûËëÏïÜüòÒàÀèÈìÌùÙçÇ`']*$/;
            if (alphabeticPattern.test(value)) return "";
            return "Please enter a valid character";
        };
    
        let inputValue = event.target.value;
        if(event.target.name === "nickname" ){
            inputValue =   inputValue.replace(/\s+/g, '');
        }

    
        if (event.target.name === "nickname" || event.target.name === "firstname" || event.target.name === "lastname") {
            const alphabeticPatternError = validateName(inputValue)
            if (alphabeticPatternError) {
                controlError = alphabeticPatternError;
            }
        }

        // Proceed with other validators if no alphabeticPattern error
        if (!controlError) {
            for (let validator of this.state[formName][event.target.name].validators) {
                controlError = validator(inputValue);
                if (controlError) break;
            }
        }

        if ((event.target.name === 'firstname' || event.target.name === 'lastname') && !(event.target.value.match(/^[a-zA-Z\xC0-\uFFFF`]+([-'.\s]?[a-zA-Z\xC0-\uFFFF`]+)*$/g)) && !controlError) {
            controlError = `Your first and/or last name entries do not meet our character limit requirements. Please try again. Please call or email CTBids Help if you have any questions.
             - 844-424-3435
             - CTBIDSHelp@CaringTransitions.com`
        }

        /* sets the state of the control and form validity */
        this.setState({
            nameError: controlError ? false : true,
            [formName]: {
                ...this.state[formName],
                [event.target.name]: {
                    ...this.state[formName][event.target.name],
                    value: inputValue,
                    valid: !Boolean(controlError),
                    error: controlError
                }
            }
        },
            () => {
                /* check form validity */
                if (controlError) {
                    this.setState({ formValid: false });
                } else {
                    let formValid = true;
                    for (let control of Object.keys(this.state[formName])) {
                        if (!this.state[formName][control].valid) {
                            formValid = false;
                            break;
                        }
                    }
                    this.setState({ formValid: formValid });
                }
            });
            if(event.target.name == "nickname"){
                if (this.timeoutInterval) {
                    clearTimeout(this.timeoutInterval);
                }
                this.timeoutInterval = setTimeout(() =>  {
                    this.formatData(event, controlError);
                }, 1000);
            }  
            
    }

    /* Email validation. Check email and retypeEmail are equal or not */
    emailValidation = (event, formName) => {

        let controlError = '';

        /* checks all the validators for the control */
        for (let validator of this.state[formName][event.target.name].validators) {
            controlError = validator(event.target.value);
            if (controlError) break;
        }
        if(event.target.name === "email"){
            this.setState({
                errorMsg: event.target.value ? this.state.errorMsg : '',
               })
        }

        /* Check confirm email is equal to email */
        if (event.target.name === 'retypeEmail' && (this.state.registerFormControl.email.value.toLowerCase() !== event.target.value.toLowerCase())&& !controlError) {
            controlError = "Email does not match"
        }

        /* sets the state of the control and form validity */
        this.setState({
            [formName]: {
                ...this.state[formName],
                [event.target.name]: {
                    ...this.state[formName][event.target.name],
                    value: event.target.value,
                    valid: !Boolean(controlError),
                    error: controlError
                }
            }
        },
            () => {
                /* check form validity */
                if (controlError) {
                    this.setState({ formValid: false });
                }
                else {
                    let formValid = true;
                    for (let control of Object.keys(this.state[formName])) {
                        if (!this.state[formName][control].valid) {
                            formValid = false;
                            break;
                        }
                    }
                    this.setState({ formValid: formValid });
                }

                let retypeEmailError = "Email does not match";
                /* Check confirm email is equal to email */
                if (event.target.name === 'email' && this.state.registerFormControl.retypeEmail.value && (this.state.registerFormControl.retypeEmail.value !== event.target.value)) {
                    this.setState({
                        [formName]: {
                            ...this.state[formName],
                            retypeEmail: {
                                ...this.state[formName].retypeEmail,
                                valid: !Boolean(retypeEmailError),
                                error: retypeEmailError
                            }
                        },
                        formValid: false
                    });
                } else if (event.target.name === 'email' && this.state.registerFormControl.retypeEmail.value && (this.state.registerFormControl.retypeEmail.value === event.target.value)) {
                    retypeEmailError = ""
                    this.setState({
                        [formName]: {
                            ...this.state[formName],
                            retypeEmail: {
                                ...this.state[formName].retypeEmail,
                                valid: !Boolean(retypeEmailError),
                                error: retypeEmailError
                            }
                        }
                    });
                }
                this.formatData(event, controlError);
            });
    }


      /* otp generated when mobile number changed */
    generateOtp = (flag) => {
        let value = this.state.registerFormControl.phonenumber.value.replace(/\D/g, '');
        this.setState({
            getOtpType: flag,
            mobileLoading: true,
        }, () => {
            const data = {
                "data": {
                    "mobile": value,
                    "otpvia": flag,
                }
            };
            AuthService.verifyMobileOtp(data).then(res => {
                this.setState({
                    isOtpSent: true,
                    mobileLoading: false,
                });

            }).catch(error => {
                this.setState({
                    mobileLoading: false,
                    otpMessage: error.message
                })
            })

        });
    }

    submitOtp = ()=>{
        let value = this.state.registerFormControl.phonenumber.value.replace(/\D/g, '');
        const data = {
            "data": {
                "mobile": value,
                "token": this.state.mobile.otp.value,
            }
        };
        AuthService.checkOtpVerify(data).then(res => {
            this.setState({
                otpMessage: 'Otp Verified',
                otpSuccess: true,
                tempVerifyPhoneNumber :  this.state.registerFormControl.phonenumber.value,
                phoneNumberDisabled: true,
            });

    
            setTimeout(() => {
                this.setState({
                    ...this.state,
                    showPhoneNumberModel: false,
                    otpMessage: '',
                    isOtpSent: false,
                    otpSuccess: false,
                    isVerified: true,
                    mobile: {
                        ...this.state.mobile,
                        otp: {
                            ...this.state.mobile.otp,
                            value: ''
                        }
                    }
                })
            }, 2000);

        }).catch(error => {
            this.setState({
                otpMessage: error.message,
                otpSuccess: false,
            })
        })
    }

    resendOtpfn = () =>{

        this.setState({
            resendOtp: true,
        })
        let value = this.state.registerFormControl.phonenumber.value.replace(/\D/g, '');
        const data = {
            "data": {
                "mobile": value,
                "otpvia": this.state.getOtpType,
            }
        };
        AuthService.resendOtp(data).then(res => {
            this.setState({
                otpSuccess: true,
                otpMessage: 'Resend OTP Successfully',
                resendOtp: false,


            })
            setTimeout(() => {
                this.setState({
                    otpMessage: '',
                    resendOtp: false,

                })
            }, 3000);
           

        }).catch(error => {
            this.setState({
                otpSuccess: false,
                otpMessage: error.message,
                resendOtp: false,
            })
        })


        
    }

    phonenumberValidation = (event, formName) => {
        let inputError = '';
        if (event.target.name === 'phonenumber') {
            const eventValue = event.target.value ? mobileNumberFormat(event.target.value, this.state.registerFormControl.phonenumber.value) : '';
            event.target.value = eventValue ? eventValue : event.target.value;
        }
        /* check validation */
        for (let validator of this.state.registerFormControl[event.target.name].validators) {
            inputError = validator(event.target.value);
            if (inputError) break;
        }


        this.setState({
            registerFormControl: {
                ...this.state.registerFormControl,
                [event.target.name]: {
                    ...this.state.registerFormControl[event.target.name],
                    value: event.target.value,
                    error: inputError,
                    valid: Boolean(!inputError)
                }
            },
        }, () => {

            if (inputError) {
                this.setState({ formValid: false });
            } else {
                let formValid = true;
                for (let control of Object.keys(this.state[formName])) {
                    if (!this.state[formName][control].valid) {
                        formValid = false;
                        break;
                    }
                }
                this.setState({ formValid: formValid });
            }
      
        });
    };


    phonenumberValidations = (event, formName) => {

        let inputError = ''
        event.target.value = event.target.value.replace(/[^0-9()\s-]/g, '');
        const eventValue = event.target.value ? mobileNumberFormat(event.target.value, this.state.registerFormControl.phonenumber.value) : '';
        event.target.value = eventValue ? eventValue : event.target.value;

        for (let validator of this.state.registerFormControl.phonenumber.validators) {
            inputError = validator(event.target.value);
            if (inputError) break;
        }

        this.setState({
            [formName]: {
                ...this.state[formName],
                phonenumber: {
                    ...this.state[formName].phonenumber,
                    value: event.target.value,
                    valid: Boolean(!inputError),
                    error: inputError
                }
            }
        });
    }
    
    editPhNumberFn =()=> {
        this.setState({phoneNumberDisabled: false})
    }

    showPhoneVerifyModel = () => {
       let value = this.state.registerFormControl.phonenumber.value.replace(/\D/g, '');
        const data = {
            "data": {
                "mobile": value
            }
        };
        AuthService.checkDetails(data).then(res => {
            const result = res.data.data;
            if(result.valid){
                this.setState({
                    showPhoneNumberModel: true
                })
            }else{
                this.setState({
                    registerFormControl: {
                        ...this.state.registerFormControl,
                        phonenumber: {
                            ...this.state.registerFormControl.phonenumber,
                            error: result.message
                        }
                    }
                });
            }
        }).catch(error => {
            this.setState({
                errorMsg:  error.message 
            })
        })
    }


    onMobileChange = (event) => {
        let value = event.target.value.replace(/\D/g, '');

        this.setState({
            mobile: {
                ...this.state.mobile,
                otp: {
                    ...this.state.mobile.otp,
                    value : value
                }
            }
        });
    };


    hideMobileModal = () => {
        this.setState({
            ...this.state,
            showPhoneNumberModel: false,
            isOtpSent: false,
            otpMessage: '',
            otpSuccess: false,
            mobile: {
                ...this.state.mobile,
                otp: {
                    ...this.state.mobile.otp,
                    value: ''
                }
            }
         
        });
    }

    /* get longer token validity */
    keepMeSignin = (event) => {
        this.setState({ remember: event.target.checked });
    };

    // logRocketSetUp() {
    //     setTimeout(() => {
    //         let userdetails = store.getState().user;
    //         LogRocket.init(logRocketDevId);
    //         LogRocket.identify(userdetails.id, {
    //             name: `${userdetails.lastName}, ${userdetails.firstName}`,
    //             email: userdetails.email,

    //             // Add your own custom user variables here, ie:
    //             subscriptionType: 'pro'
    //         });
    //     }, 5000);
    // }

    /* called when signin button is clicked */
    onSignin = (event) => {
        event.preventDefault();
        if (this.state.formValid) {
            this.setState({
                signInError: ''
            });
            store.dispatch({ type: 'SET_SIGNIN_FORM_LOADING', payload: true });
            const data = {
                data: {
                    username: this.state.formControls.email.value,
                    password: btoa(this.state.formControls.password.value),
                    'keep-user-logged-in': this.state.remember
                }
            };

            /* api call to get user token */
            AuthService.logIn(data)
                .then((response) => {
                    // const temp = {};
                    // temp.push(response);

                    const jsonData = response.data;
                    loginWithRes({ [ACCESS_TOKEN]: jsonData['accessToken'], [REFRESH_TOKEN]: jsonData['refreshToken'] }, {props: this.props}).then(
                        userData => {
                            //this.logRocketSetUp();
    
                            this.handleJiraButton(false, true);
                            const paramsValue = this.props.history.location.search;
                            const decoded = Buffer.from(paramsValue, "base64").toString("ascii");
                            if (decoded) {
                                store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In', fromBannerBtn: false } });
                                this.props.history.push(decoded);
                            }
                            setPmSteps(userData);
                            if(this.props.toggleSignInModal.fromBannerBtn) {
                                pmAutoNavigateToNextScreen(this.props, this.props.user, null, null, null, false, false, this.props.toggleSignInModal.fromBannerBtn);
                            }
                            store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In', fromBannerBtn: false } });
                            let dataLayerData = {
                                'event': 'sign_in',
                                'title': this.props?.user?.id
                            }
                            addDataLayer(dataLayerData)
                        }
                    );
                    // const jsonData = {}
                })
                .catch((error) => {
                    store.dispatch({ type: 'SET_SIGNIN_FORM_LOADING', payload: false });
                    // TODO: Error message handle
                    this.setState({
                        signInError: error.message
                    });
                });
        }
    }

    /* Called when close button click */
    handleClose = () => {
        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
    }

    /** Called when tab click */
    onSelect = (key) => {

        /** Setting which tab is active */
        this.setState({
            activeKey: key,
            formValid: false
        });
    }

    /** Called when bottom page link click */
    tabNavigate = () => {

        /** Based on active key page is redirecting */
        this.setState({
            activeKey: this.state.activeKey === 'Sign-Up' ? 'Sign-In' : 'Sign-Up'
        })
    }

    /** Called after sing complete in Google */
    responseGoogle = async (response) => {
        const data = {
            data: {
                token: response.tokenObj.id_token
            }
        };
        // const data = {
        //     data: {
        //         firstname: response.profileObj.givenName,
        //         lastname: response.profileObj.familyName,
        //         nickname: (response.profileObj.givenName + response.profileObj.familyName).toLocaleLowerCase(),
        //         email: response.profileObj.email,
        //         password: null
        //     }
        // };
        // this.registerAPICall(data);
        this.socialMediaSignInAndSignUp(data, 'google', response);
    };

    /** Called after sing complete in Facebook */
    responseFacebook = async (response) => {

        if (response.status !== 'unknown') {
            const data = {
                data: {
                    token: response.accessToken
                }
            };
            // const data = {
            //     data: {
            //         firstname: response.first_name,
            //         lastname: response.last_name,
            //         nickname: (response.first_name + response.last_name).toLocaleLowerCase(),
            //         email: response.email,
            //         password: null
            //     }
            // };
            // this.registerAPICall(data);

            this.socialMediaSignInAndSignUp(data, 'facebook', response);
        }
    };

    /** Called after sing complete in Apple */
    responseApple = async (response) => {
        this.setState({
            proxyEmail: false
        }, () => {
            this.appleSignHandle(response);
        });
    };

    appleSignHandle = (response) => {
        if (!this.state.proxyEmail) {
            const data = {
                data: {
                    user: {},
                    token: response['authorization']['id_token']
                }
            };

            if (response.hasOwnProperty('user')) {
                data['data']['user']['email'] = response['user']['email'];
                data['data']['user']['firstname'] = response['user']['name']['firstName'];
                data['data']['user']['lastname'] = response['user']['name']['lastName'];
            }

            // const data = {
            //     data: {
            //         firstname: response['user']['name']['firstName'],
            //         lastname: response['user']['name']['lastName'],
            //         nickname: (response['user']['name']['firstName'] + response['user']['name']['lastName']).toLocaleLowerCase(),
            //         email: response['user']['email'],
            //         password: null
            //     }
            // };
            // this.registerAPICall(data);
            this.socialMediaSignInAndSignUp(data, 'apple', response);

        }
    }

    compareNewField = (value) => {
        if (value === this.state.registerFormControl.newPassword.value) return '';

        return 'Password does not match';
    };

    signUpSubmit = (event) => {
        event.preventDefault();
        this.setState({
            signUpLading: true,
            signUpError: ''
        })
        const data = {
            data: {
                firstname: this.state.registerFormControl.firstname.value,
                lastname: this.state.registerFormControl.lastname.value,
                nickname: this.state.registerFormControl.nickname.value,
                email: this.state.registerFormControl.email.value,
                utmsource: this.props.googleAdsValue.user_type ? this.props.googleAdsValue.user_type : null,
                utmcampaign: this.props.googleAdsValue.campaign_type ? this.props.googleAdsValue.campaign_type : null,
                // mobile: this.state.registerFormControl.phonenumber.value.replace(/\D/g, '')
            }
        };
        this.registerAPICall(data);

    }

    registerAPICall = (data) => {
        this.setState({
            displayname: data.data.firstname + ' ' + data.data.lastname
        });
        authService.registerAPI(data).then(
            response => {
                this.setState({
                    signUpLading: false,
                    welcomeMessageShow: true
                });
            }
        ).catch((error) => {
            this.setState({
                signUpLading: false,
                signUpError: error.message
            });
            // TODO: Error message handle
        });
    }

    /* validation of password strength */
    checkPasswordStrength = (password) => {
        const lowerRegExp = new RegExp("^(?=.*[a-z])");
        const upperRegExp = new RegExp("^(?=.*[A-Z])");
        const numericRegExp = new RegExp("^(?=.*[0-9])");
        const lengthRegExp = new RegExp("^(?=.{8,15})");
        const symbolRegExp = new RegExp(/[ `!@#$%^&*]/);

        let strength = {
            status: 0,
            lower: false,
            upper: false,
            numeric: false,
            symbol: false,
            count: false
        };

        /* check for lowercase character in password */
        if (lowerRegExp.test(password)) {
            strength.status += 1;
            strength.lower = true;
        }

        /* check for uppercase character in password */
        if (upperRegExp.test(password)) {
            strength.status += 1;
            strength.upper = true;
        }

        /* check for number in password */
        if (numericRegExp.test(password)) {
            strength.status += 1;
            strength.numeric = true;
        }

        /* check for Minimum 8 - Maximum 15 characters */
        if (lengthRegExp.test(password) && password.length < 16) {
            strength.status += 1;
            strength.count = true;
        }

        /* check for symbol in password */
        if (symbolRegExp.test(password)) {
            strength.status += 1;
            strength.symbol = true;
        }

        /* set password strength */
        this.setState({ passwordStrength: { ...strength } });

        if (!password || strength.status === 5) {
            return '';
        }

        return 'Password should follow rules';
    };

    terms = () => {
        // this.handleClose();
        // this.props.history.push('/terms');
        window.open("/terms", '_blank');
    }

    forgotPasswordOpen = (flag) => {
        this.handleClose();
        store.dispatch({ type: 'TOGGLE_FORGOT_PASSWORD', payload: { open: true, mode: flag } });
    }

    compareRetypeField = (value) => {
        if (this.state.registerFormControl.retypePassword.value) {
            setTimeout(() => {
                if (this.state.registerFormControl.retypePassword.value !== value) {
                    this.setState({
                        registerFormControl: {
                            ...this.state.registerFormControl,
                            retypePassword: {
                                ...this.state.registerFormControl.retypePassword,
                                error: 'Password does not match',
                                valid: false
                            }
                        },
                        formValid: false
                    });
                } else if (this.state.registerFormControl.retypePassword.value === value) {
                    this.setState({
                        registerFormControl: {
                            ...this.state.registerFormControl,
                            retypePassword: {
                                ...this.state.registerFormControl.retypePassword,
                                error: '',
                                valid: true
                            }
                        }
                    });
                    this.setState({ formValid: Validators.checkFormValid({ ...this.state.registerFormControl }) });
                }
            });
        }

        return '';
    };

    socialMediaSignInAndSignUp = (data, media, extraData) => {
        switch (media) {
            case "google":
                this.googleAuth(data, media, extraData);
                break;
            case "facebook":
                this.facebookAuth(data, media, extraData);
                break;
            case "apple":
                this.appleAuth(data, media, extraData);
                break;
            default:
                console.error("Out of range");
                break;
        }

    }
    googleAuth = (data, media, extraData) => {
        const checkData = {
            data: {
                email: extraData.profileObj.email
            }
        };
        authService.googleAuthCheck(checkData).then(existCheck => {
            const existCheckData = existCheck.data.data;
            if (!existCheckData[0].exist) {
                authService.googleAuth(data).then(
                    response => {
                        const jsonData = response.data;
                        loginWithRes({ [ACCESS_TOKEN]: jsonData['accessToken'], [REFRESH_TOKEN]: jsonData['refreshToken'] }, {props: this.props}).then((response) => {
                            //this.logRocketSetUp();
                            this.handleJiraButton(false, true);
                            store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
                        });
                    }
                ).catch(error => {
                    store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
                    store.dispatch({ type: "ERROR_MODAL", payload: { show: true, message: error.message ? error.message : "Something went wrong" } });
                });
            } else {
                store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
                store.dispatch({ type: "TOGGLE_CHECK_EXISTS_MODAL", payload: { show: true, extraData: { media, data } } });
            }
        }).catch(error => error);
    }

    facebookAuth = (data, media, extraData) => {
        if (extraData.email) {
            const checkData = {
                data: {
                    email: extraData.email
                }
            };
            authService.facebookAuthCheck(checkData).then(existCheck => {
                const existCheckData = existCheck.data.data;
                if (!existCheckData[0].exist) {
                    authService.facebookAuth(data).then(
                        response => {
                            const jsonData = response.data;
                            loginWithRes({ [ACCESS_TOKEN]: jsonData['accessToken'], [REFRESH_TOKEN]: jsonData['refreshToken'] }, {props: this.props}).then((response) => {
                                //this.logRocketSetUp();
                                this.handleJiraButton(false, true);
                                store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
                            });
                        }
                    ).catch(error => {
                        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
                        store.dispatch({ type: "ERROR_MODAL", payload: { show: true, message: error.message ? error.message : "Something went wrong" } });
                    });
                } else {
                    store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
                    store.dispatch({ type: "TOGGLE_CHECK_EXISTS_MODAL", payload: { show: true, extraData: { media, data } } });
                }
            }).catch(error => error);
        } else {
            store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
            store.dispatch({ type: "TOGGLE_CHECK_EXISTS_MODAL", payload: { show: true, extraData: { media, data, error: true, errorMessage: extraData?.error?.code == 4 ? authErrorMessage.facebookUnavailable : authErrorMessage.facebookEmailEnable } } });

        }
    }

    appleAuth = (data, media, extraData) => {
        if (extraData['user'] && extraData['user']['email']) {
            const checkData = {
                data: {
                    email: extraData['user']['email']
                }
            };
            authService.appleAuthCheck(checkData).then(existCheck => {
                const existCheckData = existCheck.data.data;
                if (!existCheckData[0].exist) {
                    authService.appleAuth(data).then(
                        response => {
                            const jsonData = response.data;
                            loginWithRes({ [ACCESS_TOKEN]: jsonData['accessToken'], [REFRESH_TOKEN]: jsonData['refreshToken'] }, {props: this.props}).then((response) => {
                                //this.logRocketSetUp();
                                this.handleJiraButton(false, true);
                                store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
                            });
                        }
                    ).catch(error => {
                        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
                        const { message, link } = getFormattedAppleLinkAndMessage(error.message);
                        store.dispatch({ type: "ERROR_MODAL", payload: { show: true, message: message ? message : "Something went wrong", link: link ? link : null } });
                    });
                } else {
                    store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
                    store.dispatch({ type: "TOGGLE_CHECK_EXISTS_MODAL", payload: { show: true, extraData: { media, data } } });
                }
            }).catch(error => error);
        } else {
            authService.appleAuth(data).then(
                response => {
                    const jsonData = response.data;
                    loginWithRes({ [ACCESS_TOKEN]: jsonData['accessToken'], [REFRESH_TOKEN]: jsonData['refreshToken'] }, {props: this.props}).then((response) => {
                        //this.logRocketSetUp();
                        this.handleJiraButton(false, true);
                        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
                    });
                }
            ).catch(error => {
                store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
                const { message, link } = getFormattedAppleLinkAndMessage(error.message);
                store.dispatch({ type: "ERROR_MODAL", payload: { show: true, message: message ? message : "Something went wrong", link: link ? link : null } });
            });
            // store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
            // store.dispatch({ type: "TOGGLE_CHECK_EXISTS_MODAL", payload: { show: true, extraData: { media, data, error: true, errorMessage: 'Please enable share email option in apple account setting to enable sign in with ctbids using apple account' } } });
        }
    }

    onRequest = () => {
        this.setState({
            formControls: {
                ...this.state.formControls,
                email: {
                    ...this.state.formControls.email,
                    value: '',
                    valid: false,
                    error: ''
                },
                password: {
                    ...this.state.formControls.password,
                    value: '',
                    valid: false,
                    error: ''
                }
            }
        })
    }

    nicknameCheck = (event) => {
        const check = this.state.registerFormControl.nickname.valid;
        // this.formatData(event, !check);
    }

    formatData = (event, valid) => {
        if ((event.target.name === "nickname" || event.target.name === "email") && !valid) {
            this.setState({
                details: {
                    ...this.state.details,
                    [event.target.name]: {
                        ...this.state.details[event.target.name],
                        loading: true
                    }
                }
            }, () => {
                if (event.target.name === "email" && event.target.value === this.state.registerFormControl.retypeEmail.value && this.state.nameError) {
                    this.setState({
                        formValid: true
                    })
                }
                const data = {
                    data: {
                        [event.target.name]: event.target.value
                    }
                };
                this.checkDetails(data, event.target.name);
            });
        }

    }

    checkDetails = (data, name) => {
        AuthService.checkDetails(data).then(res => {
            const result = res.data.data;
            if(name === 'email'){
                this.setState({
                    errorMsg: ''
                })
            }
            if( name === 'nickname'){
                this.setState({
                    nickNameErroMsg: ''
                })
            }
            this.setState({
                details: {
                    ...this.state.details,
                    [name]: {
                        loading: false,
                        exists: !result.valid,
                        message: result?.message
                    }
                }
            });
        }).catch(error => {
            if(name === 'email'){
                this.setState({
                    errorMsg:  error.message 
                })
            }
            if( name === 'nickname'){
                this.setState({
                    nickNameErroMsg:  error.message 
                })
            }
            this.setState({
                signUpError: name === 'email' || name === 'nickname' ? '' : this.state.signUpError,
               
                details: {
                    ...this.state.details,
                    [name]: {
                        loading: false,
                        exists: false,
                    }
                }
            });
            console.error(error);
        });
    }

    clearConsole = () => {
        console.clear();
    }

    handleJiraButton = (flag, forceUpdate = false) => {
        if (!this.props.toggleSignInModal.open || forceUpdate) {
            showAndHideJiraButton(flag);
        }
    }

    showTermsAndCondition = () => {
        this.setState({ 
            signTermsConditions: true
        })
    }

    handleCloseTerms = () => {
        this.setState({
            signTermsConditions: false
        })
    }

    render() {
        // const isButtonDisabled = Object.values(this.state.registerFormControl).some(field =>  !field.valid) || this.state.signUpError ||this.state.nickNameErroMsg || Boolean(this.state.details.email.message) || Boolean(this.state.details.nickname.message);

        return (
            <div className="sign-in-container">
                <Modal id="sign-in-modal"
                    show={this.props.toggleSignInModal?.open} animation={false}
                    size="lg" onHide={this.handleClose} className={`${this.state.innerWidth > 767 ? 'right fade animate__animated animate__fadeInRight' : ''} ${this.props.setExtraZIndex ? 'enable-extra-z-index' : ''}`}
                    aria-labelledby="contained-modal-title-vcenter"
                >
                    <Modal.Body className="h-100">
                        {
                            this.state.welcomeMessageShow ?
                                <div className="welcome-message">
                                    <div className="message-header d-flex">
                                        <div className="back-to-home d-flex align-items-center clickable" onClick={this.handleClose}>
                                            <div className="back-icon d-flex align-items-center justify-content-center"><i className="fas fa-arrow-left"></i></div>Back to Home
                                        </div>
                                    </div>
                                    <div className="message-body d-flex flex-column justify-content-center">
                                        <h2>Welcome to CTBids</h2>
                                        <div className="user-name h5 text-bold">Hey {this.state.displayname}</div>
                                        <div className="h5">
                                            Wow! Thanks for registering an account
                                            <span> with <span className="text-bold">CTBids</span>. Before we get started, we'll</span> need to verify your email.
                                        </div>
                                        <div className="h5 mt-05">
                                            Please click the verification link which we have sent to your registered email address.
                                        </div>
                                    </div>
                                </div> :
                                <div className="h-100 content-main">
                                    <div className="first-section">
                                        <div className="close-icon-main" onClick={this.handleClose}>
                                            <div className="icon-close"></div>
                                        </div>
                                        <div className="nav-container">
                                            <Nav className="justify-content-around" activeKey={this.state.activeKey} onSelect={(key) => { this.onSelect(key) }}>
                                                {/* <Nav.Item>
                                                    <Nav.Link eventKey="Sign-Up">Sign Up</Nav.Link>
                                                </Nav.Item> */}
                                                <Nav.Item>
                                                    {this.state.activeKey === "Sign-In" ? <Nav.Link eventKey="Sign-In">Sign In</Nav.Link> :  <Nav.Link eventKey="Sign-Up">Sign Up</Nav.Link>}
                                                </Nav.Item>
                                            </Nav>
                                        </div>
                                        {/* {
                                            this.state.activeKey === 'Sign-In' ?
                                                <div className="signin-content d-flex align-items-center justify-content-center">
                                                    <div className="sub">
                                                        <span className="bold">Existing user: </span>
                                                        If you already have an old account?
                                                        <span className="login clickable" onClick={() => this.forgotPasswordOpen('Existing-User')}> Click here</span> to login
                                                    </div>
                                                </div>
                                                : null
                                        } */}
                                        <div className="signup-content">
                                            <div className="word">
                                                Sign {this.state.activeKey === 'Sign-In' ? 'In' : 'Up'} with Your Social Media Account
                                            </div>
                                            {
                                                this.state.proxyEmail ?
                                                    <div className="api-error">
                                                        Please enable share email
                                                    </div> : null
                                            }

                                            <div className="media-link">
                                                <div className="media-container">
                                                    <GoogleLogin
                                                        clientId={socialAuthCredential.google.clientId}
                                                        render={renderProps => (
                                                            <img onClick={renderProps.onClick} src={googleRegister} className="clickable" alt="GoogleLogin" />
                                                        )}
                                                        onSuccess={this.responseGoogle}
                                                        onFailure={(error) => this.clearConsole()}
                                                        onRequest={this.onRequest}
                                                        cookiePolicy={'single_host_origin'} />
                                                </div>
                                                <div className="media-container">
                                                    <FacebookLogin
                                                        appId={socialAuthCredential.facebook.appId}
                                                        autoLoad={false}
                                                        fields="first_name,last_name,email"
                                                        callback={this.responseFacebook}
                                                        onClick={this.onRequest}
                                                        onFailure={(error) => this.clearConsole()}
                                                        scope="public_profile,email"
                                                        render={renderProps => (
                                                            <img onClick={renderProps.onClick} src={facebookRegister} className="clickable" alt="FacebookLogin" />
                                                        )}
                                                    />
                                                </div>
                                                <div className="media-container">
                                                    <AppleSignin
                                                        authOptions={{
                                                            clientId: `${socialAuthCredential.apple.clientId}`,
                                                            scope: 'email name',
                                                            redirectURI: `${socialAuthCredential.apple.redirectURI}`,
                                                            usePopup: true,
                                                        }}
                                                        uiType="light"
                                                        onSuccess={this.responseApple}
                                                        onError={(error) => this.clearConsole()}
                                                        render={renderProps => (
                                                            <img onClick={renderProps.onClick} src={appleRegister} className="clickable" alt="AppleSignIn" />
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                            <div className="or-container">
                                                <div>Or</div>
                                            </div>
                                        </div>
                                        {
                                            this.state.activeKey === 'Sign-In' ?
                                                <div className="form-container">
                                                    <Form className="w-70" onSubmit={this.onSignin}>
                                                        <Form.Group controlId="formBasicEmail">
                                                            <Form.Label className="required">Email</Form.Label>
                                                            <Form.Control type="email" name="email" autoFocus value={this.state.formControls.email.value} onChange={(event) => this.onInputValidation(event, 'formControls')} placeholder="Email" />
                                                            <div className="text">
                                                                {
                                                                    this.state.formControls.email.error ? <small className="text-danger">{this.state.formControls.email.error}</small> : null
                                                                }
                                                            </div>
                                                        </Form.Group>

                                                        <Form.Group controlId="signInPassword" className="password-field">
                                                            <Form.Label className="required">Password</Form.Label>
                                                            <Form.Control type={this.state.showPassword ? 'text' : 'password'} name="password" value={this.state.formControls.password.value} placeholder="********" onChange={(event) => this.onInputValidation(event, 'formControls')} />
                                                            <span className={`password-icon fa ${!this.state.showPassword ? 'fa-eye-slash' : 'fa-eye'} fa-flip-horizontal clickable`} onClick={this.togglePassword}></span>
                                                            <div className="text">
                                                                {
                                                                    this.state.formControls.password.error ? <small className="text-danger">{this.state.formControls.password.error}</small> : null
                                                                }
                                                            </div>
                                                        </Form.Group>
                                                        <Form.Group controlId="formBasicCheckbox">
                                                            <Form.Check type="checkbox" label="Keep me signed in" onChange={this.keepMeSignin} />
                                                        </Form.Group>
                                                        <Form.Group>
                                                            <Form.Label>By clicking Sign In you accept our</Form.Label><br />
                                                            <Form.Label className="text-secondary clickable" onClick={() => {window.open("https://assets.ctbids.com/buyer/CTBidsTermsandConditions1.10.25.pdf", "_blank")}}>Terms and Conditions</Form.Label>
                                                        </Form.Group>
                                                        {
                                                            this.state.signInError ? <div className="api-error mb-3">
                                                                {this.state.signInError}
                                                            </div> : null
                                                        }
                                                        <div className="form-button d-md-flex align-items-center justify-content-between">
                                                            {
                                                                this.props.signinFormLoading ? <Button variant="secondary" disabled>
                                                                    Sign In {' '} <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                                </Button> : <Button variant="secondary" type="submit">
                                                                    Sign In
                                                                </Button>
                                                            }

                                                            <div className="forget clickable" onClick={() => this.forgotPasswordOpen('Forgot-Password')}>Forgot/Reset password?</div>
                                                        </div>

                                                    </Form>
                                                </div> :
                                                <div className="sign-up-form-container">
                                                    <div className="w-70">
                                                        <div className="email-signup">Sign Up with Your Email Address</div>
                                                        <Form onSubmit={this.signUpSubmit}>
                                                            <Form.Group controlId="firstname">
                                                                <Form.Label className="required">First Name</Form.Label>
                                                                <Form.Control type="text" placeholder="Firstname" name="firstname" onChange={(event) => this.onInputValidation(event, 'registerFormControl')} autoFocus />
                                                                <div className="text">
                                                                    {
                                                                        this.state.registerFormControl.firstname.error ? <small className="text-danger">{this.state.registerFormControl.firstname.error}</small> : null
                                                                    }
                                                                </div>
                                                            </Form.Group>
                                                            <Form.Group controlId="lastname">
                                                                <Form.Label className="required">Last Name</Form.Label>
                                                                <Form.Control type="text" placeholder="Lastname" name="lastname" onChange={(event) => this.onInputValidation(event, 'registerFormControl')} />
                                                                <div className="text">
                                                                    {
                                                                        this.state.registerFormControl.lastname.error ? <small className="text-danger">{this.state.registerFormControl.lastname.error}</small> : null
                                                                    }
                                                                </div>
                                                            </Form.Group>
                                                            <Form.Group controlId="lastname">
                                                                <Form.Label className="required">Nickname (for display purposes)</Form.Label>
                                                                <Form.Control type="text" placeholder="Nickname" name="nickname" value={this.state.registerFormControl.nickname.value} onChange={(event) => this.onInputValidation(event, 'registerFormControl')} onBlur={(event) => this.nicknameCheck(event)} />
                                                                <div className="text">
                                                                    {
                                                                        this.state.registerFormControl.nickname.error ? <small className="text-danger">{this.state.registerFormControl.nickname.error}</small> : null
                                                                    }
                                                                    {
                                                                        this.state.details.nickname.loading ?
                                                                            <div>
                                                                                <small>Checking nickname <i className='fa fa-spinner fa-spin'></i></small>
                                                                            </div> : <div>
                                                                                {
                                                                                    !this.state.registerFormControl.nickname.error &&
                                                                                        this.state.registerFormControl.nickname.value &&
                                                                                        this.state.details.nickname.exists ?
                                                                                        <small className='text-danger'>{this.state.details.nickname.message}</small> : null
                                                                                }
                                                                            </div>
                                                                    }
                                                                </div>
                                                            </Form.Group>
                                                            <Form.Group controlId="email" className="email">
                                                                <Form.Label className="required">Email</Form.Label>
                                                                <Form.Text className="text-muted right-text">
                                                                    An email for account verification
                                                                </Form.Text>
                                                                <Form.Control type="email" placeholder="Enter email" name="email" onChange={(event) => this.emailValidation(event, 'registerFormControl')} />
                                                                <div className="text">
                                                                    {
                                                                        this.state.registerFormControl.email.error ? <small className="text-danger">{this.state.registerFormControl.email.error}</small> : null
                                                                    }
                                                                    {
                                                                        this.state.details.email.loading ?
                                                                            <div>
                                                                                <small>Checking email <i className='fa fa-spinner fa-spin'></i></small>
                                                                            </div> : <div>
                                                                                {
                                                                                    !this.state.registerFormControl.email.error &&
                                                                                        this.state.registerFormControl.email.value &&
                                                                                        this.state.details.email.exists ?
                                                                                        <small className='text-danger'>{this.state.details.email.message}</small> : null
                                                                                }
                                                                            </div>
                                                                    }
                                                                </div>
                                                            </Form.Group>
                                                            <Form.Group controlId="confirmEmail">
                                                                <Form.Label className="required">Retype Email</Form.Label>
                                                                <Form.Control type="email" placeholder="Retype email" name="retypeEmail" onChange={(event) => this.emailValidation(event, 'registerFormControl')} onPaste={(event) => event.preventDefault()} autocomplete="off" />
                                                                <div className="text">
                                                                    {
                                                                        this.state.registerFormControl.retypeEmail.error ? <small className="text-danger">{this.state.registerFormControl.retypeEmail.error}</small> : null
                                                                    }
                                                                </div>
                                                            </Form.Group>

                                                            {/* <Form.Group className="email">
                                                                <div className='d-flex'>
                                                                <Form.Label className="required">Phone Number</Form.Label>   
                                                                    {this.state.isVerified  && this.state.tempVerifyPhoneNumber == this.state.registerFormControl.phonenumber.value ?
                                                                        <div className="text-success right-text me-5" style={{marginRight: '55px'}}>
                                                                            Verified
                                                                        </div> : 
                                                                        <Form.Text className="text-muted right-text">
                                                                            You will need to verify with a one time passcode
                                                                        </Form.Text>
                                                                    }
                                                                </div>
                                                                <div className='d-flex'>
                                                                    <Form.Control type="text" placeholder="Enter phone number" disabled={this.state.phoneNumberDisabled} name="phonenumber" value={this.state.registerFormControl.phonenumber.value} onChange={(event)=>this.phonenumberValidation(event, "registerFormControl")} />
                                                                   {this.state.isVerified && this.state.tempVerifyPhoneNumber == this.state.registerFormControl.phonenumber.value  ? <Button   style={{ marginLeft: '5px', padding: "5px" }} onClick={() => this.editPhNumberFn() } variant="secondary">Edit</Button>
                                                                    : <Button  disabled={isButtonDisabled}    style={{ marginLeft: '5px', padding: "5px" }} onClick={() => this.showPhoneVerifyModel()} variant="secondary">Verify</Button>}
                                                                </div>
                                                                <div className="text">
                                                                    {
                                                                        this.state.registerFormControl.phonenumber.error ? <small className="text-danger">{this.state.registerFormControl.phonenumber.error}</small> : null
                                                                    }
                                                                </div>
                                                            </Form.Group> */}

                                                            <div className="terms">
                                                                By Clicking Sign Up you Accept Our <span className="clickable"  onClick={() => {window.open("https://assets.ctbids.com/buyer/CTBidsTermsandConditions1.10.25.pdf", "_blank")}}>Terms and Conditions</span>.
                                                            </div>
                                                            {this.state.signUpError ? (
                                                                <div className="api-error mb-4">
                                                                    {this.state.signUpError}
                                                                </div>
                                                            ) : this.state.errorMsg ? (
                                                                <div className="api-error mb-4">
                                                                    {this.state.errorMsg}
                                                                </div>
                                                            ) :this.state.nickNameErroMsg ? ( 
                                                                <div className="api-error mb-4">
                                                                     {this.state.nickNameErroMsg}
                                                                </div>
                                                            ) : null}
                                                            {/* <Button variant="secondary" type="submit" disabled={isButtonDisabled || !this.state.isVerified || this.state.errorMsg || (this.state.tempVerifyPhoneNumber !== this.state.registerFormControl.phonenumber.value) }>
                                                                Sign Up {' '}
                                                                {this.state.signUpLading && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}
                                                            </Button> */}
                                                            {
                                                                !this.state.formValid || this.state.signUpLading  || this.state.errorMsg || this.state.nickNameErroMsg ? <Button variant="secondary" disabled>
                                                                    Sign Up {' '} {this.state.signUpLading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                                                </Button> : <Button variant="secondary" type="submit">
                                                                    Sign Up
                                                                </Button>
                                                            }

                                                        </Form>
                                                    </div>
                                                </div>
                                        }
                                        <div className="text-center mt-5 mb-5 registered">
                                            {this.state.activeKey === 'Sign-In' ? 'Not' : 'Already'} Registered? <span className='text-secondary clickable' onClick={this.tabNavigate}>Sign {this.state.activeKey === 'Sign-In' ? 'Up' : 'In'}</span>
                                        </div>
                                    </div>
                                </div>
                        }
                    </Modal.Body>
                </Modal>


                {/* <Modal centered show={this.state.showPhoneNumberModel} className="change-mobile-modal" onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Body>
                        <div className="profile-modal-close-icon clickable" onClick={this.hideMobileModal}></div>
                        <div className="d-flex flex-column justify-content-center align-items-center w-100">
                            <div className="float-control" style={{ width: "90%" }}>
                                <div className="text">
                                    {
                                        this.state.registerFormControl.phonenumber.error ? <small className="error">{this.state.registerFormControl.phonenumber.error}</small> : null
                                    }
                                </div>
                                <Form.Control autoFocus type="text" id="newMobile" name="newMobile" placeholder=" "
                                    value={this.state.registerFormControl.phonenumber.value} />
                                <label htmlFor="newMobile" className="required">Phone Number</label>
                            </div>
                            {this.state.isOtpSent &&
                                <div className="float-control" style={{ width: "90%" }}>
                                    <Form.Control autoFocus type="text" id="otp" name="otp" placeholder="Enter OTP" value={this.state.mobile.otp.value}
                                         onChange={(event) => this.onMobileChange(event)} />
                                    <label htmlFor="otp" className="required">OTP</label>
                                </div>
                            }
                            <div className="mt-2">

                                <div className={`${this.state.otpSuccess ? 'text-success' : 'text-danger' } text-center m-3`}>
                                    {
                                        this.state.otpMessage? <div >{this.state.otpMessage}</div> : null
                                    }
                                </div>
                             
                                {
                                    this.state.isOtpSent ?
                                        <div className="d-flex flex-column justify-content-center align-items-center flex-sm-row">
                                            <Button variant="secondary" disabled={this.state.mobile.otp.value == ''}  onClick={() => { this.submitOtp() }}>
                                                Verify 
                                            </Button>
                                        </div> :
                                        <div className="d-flex justify-content-center align-items-center">
                                            <Button variant="outline-dark btn-white mx-2"  onClick={() => { this.generateOtp('call') }}>
                                                Call me {
                                                     this.state.loaderHandle === 'call' ?
                                                        <Spinner className="ml-1" animation="border" as="span" size="sm" /> :
                                                        null
                                                }
                                            </Button>
                                            <Button variant="secondary" onClick={() => { this.generateOtp('sms') }}>
                                                Text me  {
                                                    this.state.loaderHandle === 'sms' ?
                                                        <Spinner className="ml-1" animation="border" as="span" size="sm" /> :
                                                        null
                                                }
                                            </Button>

                                        </div>
                                }
                                {
                                    this.state.isOtpSent ? <div className="mt-2 text-center">
                                        Not received? <span className="change-email-link clickable" onClick={() => this.resendOtpfn()}>
                                            Resend {
                                                this.state.resendOtp ?
                                                    <Spinner className="ml-1" animation="border" as="span" size="sm" /> :
                                                    null
                                            }
                                        </span>
                                    </div> : null
                                }
                            </div>
                        </div>
                    </Modal.Body>
                </Modal> */}
                <Modal centered className="terms-dialog" id="terms-and-condition" show={this.state.signTermsConditions} animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <SignTermsAndCondtions />
                        <div className="d-flex align-items-center justify-content-center actions" style={{marginTop: "2rem"}}>
                            <Button variant="secondary mx-2" onClick={this.handleCloseTerms}>Close</Button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}